<template>
  <!-- 上方title -->
  <div>
    <cus-button text="訂單資訊" color="darkBlue" :isButton="false" style="padding: 0" fontSize="normal"></cus-button>
  </div>
  <!-- 下方content -->
  <div class="wrap">
    <div class="flex-box">
      <div class="title">
        <i class="bi bi-geo-alt"></i>
        來源
      </div>
      <button-radio
        :radioList="getSourceBtns"
        v-model:selectValue="orderInformation.source"
        :disabled="getSystem?.show_alert_type === 2 || getSystem?.show_alert_type === 3"
      ></button-radio>
    </div>
    <div class="flex-box">
      <div class="title">
        <i class="bi bi-grid"></i>
        類型
      </div>
      <button-radio
        :radioList="getTakeAwayBtns"
        v-model:selectValue="orderInformation.take_away_method"
        :disabled="getSystem?.show_alert_type === 2 || getSystem?.show_alert_type === 3"
      ></button-radio>
    </div>
    <div class="flex-box">
      <div class="title">
        <i class="bi bi-info-circle"></i>
        資訊
      </div>
      <div class="info-wrap">
        <cus-button
          text="訂購人資訊"
          @click="openDialog('consumer')"
          :leftIcon="
            Object.keys(orderInformation.consumer).every((el) => !orderInformation.consumer[el])
              ? ''
              : 'check-circle-fill'
          "
          leftIconClass="green-icon"
          :disabled="getSystem?.show_alert_type === 2 || getSystem?.show_alert_type === 3"
        ></cus-button>
      </div>
    </div>
    <div class="button-wrap">
      <cus-button
        text="確定"
        color="green"
        :width="100"
        :disabled="orderInformation.source === '' || orderInformation.take_away_method === ''"
        @click="handleSubmit"
        style="padding: 0; margin: 0; height: 55px"
      ></cus-button>
    </div>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
  <MemberDialog v-model="showMemberDialog" @checked="handleMemberChecked"></MemberDialog>
</template>
<script>
import { useDialog } from '@/utils/dialog';
import { getOrderButton } from '@/utils/define';
import { useGetters, useActions } from '@/utils/mapStore';
import { useRouter } from 'vue-router';
import { reactive, defineAsyncComponent, computed, getCurrentInstance, watch, ref } from 'vue';
export default {
  name: 'order-info',
  components: {
    InputInfo: defineAsyncComponent(() => import('@/components/dialog/InputInfo.vue')),
    MemberDialog: defineAsyncComponent(() => import('@/components/dialog/MemberDialog.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //按鈕清單
    const { sourceBtns, takeAwayBtns } = getOrderButton();
    const { getPermission, getSystem } = useGetters('system', ['getPermission', 'getSystem']);
    const getSourceBtns = computed(() => {
      if (getPermission.value) {
        return sourceBtns.filter((e) => getPermission.value[e.value]);
      } else {
        return sourceBtns;
      }
    });
    const getTakeAwayBtns = computed(() => {
      if (getPermission.value) {
        return takeAwayBtns.filter((e) => getPermission.value[e.value]);
      } else {
        return takeAwayBtns;
      }
    });
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //設定參數
    const orderInformation = reactive({
      source: '',
      take_away_method: '',
      consumer: {
        order_user_name: '',
        order_user_tel: '',
        outside_order_id: '',
        note: '',
        pos_note: '',
        order_take_time: '',
        order_user_address: '',
      },
    });
    const memberPhone = ref('');

    //處理彈窗資訊
    const handleConsumer = (val) => {
      orderInformation.consumer = val;
      closeDialog();
    };

    // 檢查交班狀態
    const doGetDutySection = useActions('system', ['doGetDutySection']);
    const checkDutySection = (async () => {
      await doGetDutySection();
    })();

    //送出訂單資訊
    const doCheckDeviceStatus = useActions('system', ['doCheckDeviceStatus']);
    const handleCheckDeviceStatus = async () => {
      try {
        await doCheckDeviceStatus();
        handleCheckPendingOrder();
      } catch (error) {
        handleCheckDeviceStatus();
      }
    };

    const doCheckPendingOrder = useActions('order', ['doCheckPendingOrder']);
    const getPendingOrderId = useGetters('order', ['getPendingOrderId']);
    const doCreateNewOrder = useActions('order', ['doCreateNewOrder']);
    const doAbrogateOrder = useActions('order', ['doAbrogateOrder']);
    const dorRestoreOrder = useActions('handleOrder', ['dorRestoreOrder']);
    const doCheckMember = useActions('member', ['doCheckMember']);
    const handleCheckPendingOrder = async () => {
      await doCheckPendingOrder();
      if (getPendingOrderId.value) {
        proxy
          .$confirm({
            content: '尚有未完成訂單，是否要回復訂單？',
            confirmText: '回復訂單',
            cancelText: '建立新訂單',
          })
          .then(() => {
            handleRestore();
          })
          .catch(async () => {
            await doAbrogateOrder();
            createOrder();
          });
        return;
      }
      await createOrder();
    };

    const createOrder = async () => {
      await doCreateNewOrder(orderInformation);
      if (memberPhone.value?.trim()) {
        //要有輸入門號，才需要進行檢查
        await doCheckMember(memberPhone.value);
      }
    };

    const router = useRouter();
    const handleRestore = async () => {
      try {
        await dorRestoreOrder(getPendingOrderId.value);
        router.push('/order');
      } catch {
        handleRestore('/order');
      }
    };
    const showMemberDialog = ref(false);

    const handleMemberChecked = (phone) => {
      memberPhone.value = phone;
      handleCheckDeviceStatus();
    };

    const handleSubmit = async () => {
      if (
        (orderInformation.source === 'foodpanda' || orderInformation.source === 'uber_eat') &&
        !orderInformation.consumer.outside_order_id
      ) {
        openDialog('consumer', { outsideError: '此為必填' });
        return;
      }

      if (['on_site', 'phone', 'line'].includes(orderInformation.source)) {
        showMemberDialog.value = true;
        return;
      }

      await handleCheckDeviceStatus();
    };

    return {
      getSystem,
      getSourceBtns,
      getTakeAwayBtns,
      dialogTemplate,
      openDialog,
      orderInformation,
      handleConsumer,
      handleSubmit,
      checkDutySection,
      showMemberDialog,
      handleMemberChecked,
    };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 38% 30% auto 55px;
  grid-gap: 8px;
}
.title {
  height: 32px;
  line-height: 32px;
  font-size: 1.8rem;
  margin: 4px;
  border-radius: 4px;
  background-color: $color-whiteGreen;
  color: $color-green;
  padding: 0 12px;
  i {
    margin-right: 4px;
  }
}
.flex-box {
  @include white-bg;
  height: 100%;
  padding: 4px;
  .info-wrap {
    overflow: hidden;
  }
}
.button-wrap {
  background-color: #fff;
  border-radius: 4px;
}
</style>
